import { motion } from 'framer-motion';
import { ArrowDown, Download, Send } from 'lucide-react';

const Hero = ({ handleScrollTo, isMobile }) => {
    return (
        <section id="hero" className="section min-h-screen flex items-center justify-center text-center relative overflow-hidden">
            {/* Abstract Background Elements */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-purple/20 rounded-full blur-[100px] animate-pulse-slow"></div>
            <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-secondary-blue/20 rounded-full blur-[80px] animate-float"></div>

            <div className="container relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <h2 className="text-sm md:text-base font-medium tracking-[0.2em] text-primary-purple uppercase mb-6">
                        Portfolio
                    </h2>

                    <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-6 font-outfit tracking-tighter leading-none">
                        <span className="block text-white">Tarush</span>
                        <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-400 to-gray-600">Agarwal</span>
                    </h1>

                    <p className="text-xl md:text-2xl text-gray-400 mb-12 max-w-2xl mx-auto font-light">
                        Crafting digital experiences with <span className="text-white font-medium">Code</span> & <span className="text-white font-medium">Creativity</span>.
                    </p>

                    <div className="flex gap-6 justify-center items-center flex-wrap">
                        <a
                            href="/tarush_resume.pdf"
                            className="btn btn-primary group relative overflow-hidden"
                            target="_blank"
                        >
                            <span className="relative z-10 flex items-center">
                                Download Resume <Download size={18} className="ml-2 group-hover:translate-y-1 transition-transform" />
                            </span>
                            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
                        </a>
                        <button
                            className="btn btn-outline group"
                            onClick={() => handleScrollTo('#contact')}
                        >
                            Let's Talk <Send size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </motion.div>
            </div>

            {!isMobile && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.5, duration: 1 }}
                    className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-500"
                >
                    <span className="text-xs tracking-widest uppercase">Scroll</span>
                    <ArrowDown size={20} className="animate-bounce" />
                </motion.div>
            )}
        </section>
    );
};

export default Hero;
